import React from 'react';
import ReactDOM from 'react-dom';
import Marker from './Marker.react';
import { getElementPosition, isHandheld } from '../utils';

class Seekbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onTouchEvent = this.onTouchEvent.bind(this);

  }

  componentWillUnMount() {
    this.removeMouseListeners();
  }

  removeMouseListeners() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  onMouseDown(event) {
    if (isHandheld()) return;
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);

    const playHead = ReactDOM.findDOMNode(this.refs.thumb);
    if (playHead === event.target) return;

    this.handleMouseEvent(event, true);
  }

  onMouseMove(event) {
    this.handleMouseEvent(event);
  }

  onMouseUp(event) {
    this.handleMouseEvent(event, true);
    this.removeMouseListeners();
  }

  handleMouseEvent(event, forceSeek) {
    if (isHandheld()) return;
    this.seek(event.pageX, event.type === 'mousemove', forceSeek);
  }

  onTouchEvent(event) {
    if (!event.touches || !event.touches.length) {
      this.setState({
        dragging: false
      });
      return;
    }
    this.seek(event.touches[0].clientX, event.type === 'touchmove' || event.type === 'touchstart', event.type !== 'touchmove');
  }

  onKeyDown(event) {
    const step = this.props.duration > 30 ? 5 : 1;
    switch (event.keyCode) {
      case 37: //Left
      case 40: //Down
        this.props.video.currentTime = this.props.currentTime - step;
        break;
      case 39: // Right
      case 38: // Up
        this.props.video.currentTime = this.props.currentTime + step;
        break;
      case 36: // Home
        this.props.video.currentTime = 0;
        break;
      case 35: // End
        this.props.video.currentTime = this.props.duration;
        break;
      default:
        break;
    }
  }

  onClickMarker(event, marker) {
    event.stopPropagation();
    this.props.video.currentTime = marker.position;
  }

  seek(xValue, dragging, forceSeek) {
    const barNode = ReactDOM.findDOMNode(this.refs.bar);
    if (!barNode) return;
    const mouseMoveX = xValue - getElementPosition(barNode).x;
    const offsetX = mouseMoveX / barNode.offsetWidth;
    let position = offsetX * this.props.duration;
    if (position > this.props.duration) position = this.props.duration;
    if (position < 0) position = 0;
    if (forceSeek || !this.props.seeking) {
      this.props.video.currentTime = position;
      position = null;
    }
    this.setState({
      desiredTime: position,
      dragging: dragging
    });
    if (typeof this.props.onChange === 'function') {
      this.props.onChange({time: position});
    }
  }

  render() {
    if (!this.props.duration) return null;

    const time = this.state.desiredTime ? this.state.desiredTime : this.props.currentTime;
    const playedProgress = 100 * (time / this.props.duration);
    const playedStyle = {
      width: playedProgress + '%'
    };
    let seekbarClasses = 'b-seekbar';
    let playedClasses = 'b-bar played';
    if (this.state.dragging) {
      seekbarClasses += ' active';
      playedClasses += ' dragging';
    }
    if (isHandheld()) {
      seekbarClasses += ' handheld';
    }

    let bufferedProgress = 0;
    if (this.props.video.buffered.length && !this.props.video.isLive) {
      let bufferIndex = this.props.video.buffered.length - 1;
      let end = 0;
      for (let i = 0; i < this.props.video.buffered.length; i++) {
        let endRange = this.props.video.buffered.end(i);
        if (time >= this.props.video.buffered.start(i) && time <= endRange && end < endRange) {
          bufferIndex = i;
          end = endRange;
        }
      }
      bufferedProgress = 100 * (this.props.video.buffered.end(bufferIndex) / this.props.duration);
    }
    const bufferedStyle = {
      width: bufferedProgress + '%'
    };

    let markers = null;
    if (this.props.markers && this.props.markers.length) {
      markers = (
        <div className='b-markers'>
          {this.props.markers.map(marker => <Marker text={marker.text}
            position={marker.position}
            duration={this.props.duration}
            color={marker.color}
            onClick={event => this.onClickMarker(event, marker)}
            key={marker.text + marker.position}
          />)}
        </div>
      );
    }
    return (
      <div
        className={seekbarClasses}
        ref='bar'
        tabIndex='0'
        onMouseDown={this.onMouseDown}
        onKeyDown={this.onKeyDown}
        onTouchStart={this.onTouchEvent}
        onTouchMove={this.onTouchEvent}
        onTouchCancel={this.onTouchEvent}
        onTouchEnd={this.onTouchEvent}>
        <div className='b-bar'></div>
        <div className='b-bar buffered' style={bufferedStyle}></div>
        <div className={playedClasses} style={playedStyle}>
          <div className='b-playhead-wrapper'>
            <div className='b-playhead' ref='thumb'></div>
          </div>
        </div>
        {markers}
      </div>
    );
  }
}

export default Seekbar;
